<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? `${$t('common.add')} ${$t('lab.unit')}`
          : `${$t('common.edit')} ${$t('lab.unit')}`
      "
    >
      <b-card-text> </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitItem"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{ $t("common.add") }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    
    <!-- Modal for Observations Data -->
    <b-modal
      id="modal-observations"
      size="xl"
      :title="$t('common.observations')"
      scrollable
      ok-only
    >
      <b-table
        :items="selectedObservations"
        responsive
        striped
        hover
        :fields="observationsColumns"
        primary-key="Observation ID"
        show-empty
        empty-text="No observations found"
      >
      </b-table>
    </b-modal>
    
    <b-card :title="$t('lab.lis-data')">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t("common.filter") }} {{ $t("lab.lis-data") }}</h2>
            <br />
          </b-col>

          <!-- <b-col md="4" cols="12">
            <b-form-group :label="$t('common.id')" label-for="Id">
              <b-form-input
                id="Id"
                v-model="filterId"
                :placeholder="$t('common.id')"
              />
            </b-form-group>
          </b-col> -->
          
          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.from_date')" label-for="FromDate">
              <b-form-datepicker
                id="FromDate"
                v-model="filterFromDate"
                :placeholder="$t('common.from_date')"
                locale="en"
              />
            </b-form-group>
          </b-col>
          
          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.to_date')" label-for="ToDate">
              <b-form-datepicker
                id="ToDate"
                v-model="filterToDate"
                :placeholder="$t('common.to_date')"
                locale="en"
              />
            </b-form-group>
          </b-col>
        </b-row>
        
        <!-- Search Button -->
        <b-button variant="primary" class="mt-1" @click="getLisData()">
          {{ $t('common.search') }}
        </b-button>

        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("lab.lis-data") }} {{ $t("common.table") }}</h2>
          <!-- <b-button
            v-if="$store.state.app.permissions.includes('store-unit')"
            variant="primary"
            @click="show(EditForm, 'create')"
          >
            {{ $t("common.create") }} {{ $t("lab.unit") }}
          </b-button> -->
        </div>

        <b-table
          :items="data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <!-- Index column template -->
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>
          
          <!-- Date column template -->
          <template #cell(date)="data">
            {{ getNestedProperty(data.item, 'date') }}
          </template>
          
          <!-- Protocol column template -->
          <template #cell(protocol)="data">
            {{ getNestedProperty(data.item, 'protocol') }}
          </template>
          
          <!-- Device name column template -->
          <template #cell(device_name)="data">
            {{ getNestedProperty(data.item, 'device_name') }}
          </template>
          
          <!-- Sample ID column template -->
          <template #cell(sample_id)="data">
            {{ getNestedProperty(data.item, 'sample_id') }}
          </template>
          
          <!-- Patient name column template -->
          <template #cell(data.Patients.Name)="data">
            <span v-if="data.item.data && data.item.data.Patients && data.item.data.Patients[0] && data.item.data.Patients[0].Name">
              {{ Array.isArray(data.item.data.Patients[0].Name) ? data.item.data.Patients[0].Name[1] : data.item.data.Patients[0].Name }}
            </span>
            <span v-else>-</span>
          </template>
          
          <!-- Patient gender column template -->
          <template #cell(data.Patients.Gender)="data">
            <span v-if="data.item.data && data.item.data.Patients && data.item.data.Patients[0] && data.item.data.Patients[0].Gender">
              {{ data.item.data.Patients[0].Gender }}
            </span>
            <span v-else>-</span>
          </template>
          
          <!-- Observations column template -->
          <template #cell(data.Observations)="data">
            <b-button 
              variant="primary" 
              size="sm" 
              @click="showObservations(data.item.data.Observations)"
              v-if="data.item.data && data.item.data.Observations"
            >
              {{ $t('common.view') }}
            </b-button>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                {{ $t("lab.unit") }}</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getLisData()"
            >
              <b-pagination
                v-model="page"
                :total-rows="dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BModal,
  BFormDatepicker,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import permissionChecker from "@/mixins/permissionChecker";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
 
export default {
  components: {
    DeleteModal,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BModal,
    BFormDatepicker,
  },
  mixins: [permissionChecker],
  data() {
    return {
      page: 1,
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        name: "",
        discount: "",
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        name: "",
        discount: "",
      },
      params: {
        form: {},
        path: "",
      },
      selectedObservations: [],
      observationsColumns: [
        { key: "Observation ID", label: this.$t("common.observation_id"), sortable: true },
        { key: "Value", label: this.$t("common.value"), sortable: true },
        { key: "Unit", label: this.$t("common.unit"), sortable: true },
        { key: "Abnormal Flag", label: this.$t("common.abnormal_flag"), sortable: true },
        { key: "Reference Range", label: this.$t("common.reference_range"), sortable: true },
      ],
      tableColumns: [
        { key: "index", label: this.$t("common.index"), sortable: true },
        { key: "date", label: this.$t("common.date"), sortable: true },
        { key: "protocol", label: this.$t("common.protocol"), sortable: true },
        {
          key: "device_name",
          label: this.$t("common.device_name"),
          sortable: true,
        },
        {
          key: "sample_id",
          label: this.$t("common.sample_id"),
          sortable: true,
        },
        {
          key: "data.Patients[0].Name",
          label: this.$t("common.name"),
          sortable: true,
        },
        {
          key: "data.Patients[0].Gender",
          label: this.$t("common.gender"),
          sortable: true,
        },
        {
          key: "data.Observations",
          label: this.$t("common.observations"),
          sortable: true,
        },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      testData: test,
      testName: "",
      filterId: "",
      filterFromDate: "",
      filterToDate: "",
    };
  },
  mounted() {
    this.getLisData();
    console.log(this.take);
    console.log(this.page);
  },
  methods: {
    getNestedProperty(obj, path, defaultValue = "N/A") {
      const result = path
        .split(".")
        .reduce(
          (acc, part) => (acc && acc[part] ? acc[part] : defaultValue),
          obj
        );
      // console.log("result", result);
      return result;
    },
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          name: "",
          discount: "",
          _method: "POST",
        };
      } else {
        this.createMode = false;

        this.EditForm.id = item.id;
        this.EditForm.name = item.name;
        this.EditForm.discount = item.discount;
        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },
    
    // Show observations in modal
    showObservations(observations) {
      if (observations && observations.length > 0) {
        this.selectedObservations = observations;
        this.$bvModal.show("modal-observations");
      } else {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Info",
            icon: "InfoIcon",
            variant: "info",
            text: "No observations data available",
          },
        });
      }
    },
    
    async getLisData() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/lisData?page=${this.page}&take=${
        this.take
      }&sort=-id`;

      if (this.filterId) {
        url += `&filter[id]=${this.filterId}`;
      }

      if (this.filterFromDate) {
        url += `&filter[created_at-ge]=${this.filterFromDate}`;
      }

      if (this.filterToDate) {
        url += `&filter[created_at-le]=${this.filterToDate}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/unit/${this.deleteForm.id}`)
        .then((response) => {
          this.getLisData();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      this.loading = true;
      let count = 0;
      this.errorForm.name = "";
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (!this.EditForm.name) {
        count++;
        this.errorForm.name = "The name field is required.";
      }

      if (count > 0) {
        this.loading = false;
        return false;
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/unit`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getLisData();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              if (error.response.status === 400) {
                this.loading = false;
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/unit/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getLisData();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              if (error.response.status === 400) {
                this.loading = false;
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
